import React, { useState } from "react";
import { Typography, Space, Spin, Form } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import DocumentUpload from "../../DocumentUpload/UI/DocumentUpload";
import Document from "../../DocumentUpload/Domain/Document";
import { CustomFormSelect } from "../../Utils/UI/Text";
import "./NewProject.css";
const { Text } = Typography;

export default function ProjectUploadImage({ form, record }) {
  const [type, setType] = useState(Document.MAIN_IMAGE_PROJECT);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  const onHandleChange = (value) => {
    setType(value);
  };

  const updateImage = () => {
    setLoading(true);
    setTimeout(() => {
      setPreviewImage(
        `${process.env.REACT_APP_SERVER_URL}/uploads/${record.id}`
      );
      setLoading(false);
      setUploadSuccess(true);
    }, 1500);
  };

  return (
    <div>
      <Space
        direction="vertical"
        size="large"
        style={{ width: "100%", textAlign: "center" }}
      >
        <Text type="secondary">Formatos permitidos: .webp, .svg</Text>

        <Form
          name="basic"
          initialValues={{ remember: true }}
          autoComplete="off"
          form={form}
        >
          {record && (
            <>
              <div style={{ marginBottom: "8px" }}>
                <CustomFormSelect
                  name="type"
                  placeholder="Selecciona tipo de imagen"
                  options={[
                    {
                      value: Document.MAIN_IMAGE_PROJECT,
                      label: "Imagen principal",
                    },
                    {
                      value: Document.FIRST_IMAGE_SENSORS,
                      label: "Primera imagen de sensores",
                    },
                    {
                      value: Document.SECOND_IMAGE_SENSORS,
                      label: "Segunda imagen de sensores",
                    },
                    {
                      value: Document.THIRD_IMAGE_SENSORS,
                      label: "Tercera imagen de sensores",
                    },
                    {
                      value: Document.GALLERY_IMAGE,
                      label: "Imagen de galería",
                    },
                  ]}
                  onChange={onHandleChange}
                />
              </div>
              <DocumentUpload
                type={type}
                id={record.id}
                buttonText="Seleccionar Archivo"
                updateImage={updateImage}
              />
            </>
          )}
        </Form>

        {loading ? (
          <div style={{ marginTop: "2rem" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            />
            <div style={{ marginTop: "1rem" }}>
              <Text type="secondary">Cargando imagen...</Text>
            </div>
          </div>
        ) :
        null}
        {uploadSuccess && (
          <div className="success-message"> ¡Imagen subida con éxito!</div>
        )}
      </Space>
    </div>
  );
}
